// extracted by mini-css-extract-plugin
export default {"tile":"similar-to-you--Vl2S6","tile--super-offer":"similar-to-you--3tpZn","tile__anchor":"similar-to-you--1f3Ef","tile__actions":"similar-to-you--3_qEA"};